(function() {
	'use strict';

	angular.module('gatewayApp').service("workflowSharedService", function() {
		this.viewFrom = 'changeNotificationSettingsController'
	})

	.controller('ChangeNotificationSettingsController', ChangeNotificationSettingsController);

	ChangeNotificationSettingsController.$inject = [ '$scope', '$state',
			'workflowSharedService', 'NotificationSettings', 'GlobalValues',
			'EntityPermissions', 'ScreenLog', '$stateParams',
			'$uibModalInstance', '$rootScope', 'MessageBox', 'Workflow','entity','DateUtils', '$filter'];

	function ChangeNotificationSettingsController($scope, $state, workflowSharedService,
		NotificationSettings, GlobalValues, EntityPermissions, ScreenLog,
			$stateParams, $uibModalInstance, $rootScope, MessageBox, Workflow,entity,DateUtils, $filter) {

		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenLog = ScreenLog;
		vm.saveNotificationSettings = saveNotificationSettings;
		vm.notificationSettings = {};
		vm.controlMin=null;
		vm.controlMax=null;
		vm.bankId = vm.globalValues.getBankId();
		vm.notificationSettings.bankId=vm.bankId ;
/*		$("#date_input").on("change", function () {
		     $(this).css("color", "rgba(0,0,0,0)").siblings(".datepicker_label").css({ "text-align":"center", position: "absolute",left: "10px", top:"14px",width:$(this).width()}).text($(this).val().length == 0 ? "" : ($.datepicker.formatDate($(this).attr("dateformat"), new Date($(this).val()))));
		        });*/
		
		vm.approveNotificationSettings = approveNotificationSettings;
		vm.rejectNotificationSettings = rejectNotificationSettings;
		vm.discardNotificationSettings = discardNotificationSettings;
		vm.resubmitNotificationSettings = resubmitNotificationSettings;
		vm.clear = clear;
		$scope.showButton = false;
		$scope.isShowSaveButton = false;
		$scope.showDiscardButton = false;
		$scope.isShowResubmit = false;
		$scope.isShowOkButton = false;
		vm.isPasswordPolicySelected = true;

		vm.clicked = false;
		vm.noOfDecimals=0;



		if (workflowSharedService.viewFrom == 'notificationSettingstodolist_checker') {
			vm.ViewDisable = true;

			vm.notificationSettings = angular.fromJson($rootScope.payload);
			console.log(vm.notificationSettings);
			vm.headerLabel = "Order Settings";
			vm.labelName = vm.notificationSettings.bankSpecificSettingsList.settingsDescription;
			vm.settingsName = vm.notificationSettings.bankSpecificSettingsList.settingsName;
			if(vm.notificationSettings.settingsType=='amcdate'){
				vm.settingsValue = DateUtils.convertLocalDateFromServer(vm.notificationSettings.value);
			}else{
				vm.settingsValue = vm.notificationSettings.value;
			}
			
			vm.settingsType = vm.notificationSettings.settingsType;
			vm.screenName = 'dealingAdmin';
			vm.isDisabled = true
			$scope.showButton = true;
			$scope.showDiscardButton = false;
			$scope.isShowResubmit = false;
			$scope.isShowSaveButton = false;

		} else if (workflowSharedService.viewFrom =='notificationSettingstodolist_maker') {
			vm.ViewDisable = true;
			vm.notificationSettings = angular.fromJson($rootScope.payload);
			vm.headerLabel =  "Order Settings";
			vm.labelName =  vm.notificationSettings.bankSpecificSettingsList.settingsDescription;
			vm.settingsName =  vm.notificationSettings.bankSpecificSettingsList.settingsName;
			if(vm.notificationSettings.settingsType=='amcdate'){
				vm.settingsValue = DateUtils.convertLocalDateFromServer(vm.notificationSettings.value);
			}else{
				vm.settingsValue = vm.notificationSettings.value;
			}
			vm.settingsType =  vm.notificationSettings.settingsType;
			vm.screenName = 'dealingAdmin';
			vm.isDisabled = true
			$scope.showButton = false;
			$scope.showDiscardButton = true;
			$scope.isShowSaveButton = false;
			$scope.isShowResubmit = false;
		}

		else if (workflowSharedService.viewFrom == 'notificationSettingstodolist_resubmit') {
			vm.notificationSettings = angular.fromJson($rootScope.payload);
			vm.headerLabel =  "Order Settings";
			vm.labelName =  vm.notificationSettings.bankSpecificSettingsList.settingsDescription;
			vm.settingsName = vm.notificationSettings.bankSpecificSettingsList.settingsName;
			if(vm.notificationSettings.settingsType=='amcdate'){
				vm.settingsValue = DateUtils.convertLocalDateFromServer(vm.notificationSettings.value);
			}else{
				vm.settingsValue = vm.notificationSettings.value;
			}
			
			vm.settingsType =  vm.notificationSettings.settingsType;
			vm.isDisabled = false;
			vm.screenName = 'dealingAdmin';
			$scope.isShowResubmit = true;
			$scope.isShowSaveButton = false;

		} 		else if (workflowSharedService.viewFrom == 'notificationSettingstodolist_auditlog') {
			
			vm.notificationSettings = angular.fromJson($rootScope.payload);;
			vm.headerLabel = "Order Settings";
			vm.labelName = vm.notificationSettings.bankSpecificSettingsList.settingsDescription;
			vm.settingsName = vm.notificationSettings.settingsName;
			if(vm.notificationSettings.settingsType=='amcdate'){
				vm.settingsValue = DateUtils.convertLocalDateFromServer(vm.notificationSettings.value);
			}else{
				vm.settingsValue = vm.notificationSettings.value;
			}
			vm.settingsType = vm.notificationSettings.settingsType;
			vm.isDisabled = true;
			$scope.isShowResubmit = false;
			$scope.isShowSaveButton = false;
			$scope.isShowOkButton = true;

		} 
		else {
			vm.notificationSettings.isDefault = false;
			vm.notificationSettings.settingsName =  $stateParams.settingsName;
			vm.notificationSettings.value = $stateParams.settingsValue;
			vm.notificationSettings.settingsType = $stateParams.settingsType;
			
			vm.headerLabel = $stateParams.headerLabel;
			vm.labelName = $stateParams.labelName;
			vm.settingsName = $stateParams.settingsName;
			if($stateParams.settingsType=='amcdate'){
			
				
				vm.settingsValue = moment($stateParams.settingsValue,'DD/MM').toDate();
			}else{
				vm.settingsValue = $stateParams.settingsValue;
			}
			
			vm.settingsType = $stateParams.settingsType;
			vm.screenName = $stateParams.screenName;
			$scope.isShowSaveButton = true;
			console.log(vm.notificationSettings.value);
		}
		function saveNotificationSettings() {

			if(vm.settingsType == 'yesorno' ){
				vm.notificationSettings.value = vm.settingsValue;
			}
			
			NotificationSettings.updateNotificationSettings(vm.notificationSettings, onSaveSuccess, onSaveError)	

			
		}

		function onSaveSuccess(result) {
			$scope.$emit('Refresh');
			$uibModalInstance.close();

		}

		function onSaveError() {

			vm.clicked = false;
		}

		function approveNotificationSettings() {
			NotificationSettings.approve({
				"taskId" : $rootScope.taskID
			}, onApproveSuccess, onApproveError);
			
		}

		function onApproveSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close();
		}
		function onApproveError(error) {
			vm.clicked=false;
		}

		function rejectNotificationSettings() {
			Workflow.rejectTask($rootScope.taskID);
		}

		function discardNotificationSettings() {
			NotificationSettings.discard({
				"taskId" : $rootScope.taskID
			}, onDiscardSuccess, onDiscardError);
			
		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close();
		}
		function onDiscardError(error) {

		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close(result);
			$uibModalInstance.close();
		}

		function onResubmitError(error) {
			vm.clicked=false;
		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function resubmitNotificationSettings() {
			if(vm.settingsType == 'yesorno' ){
				vm.notificationSettings.value = vm.settingsValue;
			}
			
			NotificationSettings.resubmitForEdit({
					"taskId" : $rootScope.taskID
				}, vm.notificationSettings, onResubmitSuccess, onResubmitError);
		

			
		}
		
		


	}
})();
